<template>
  <div>
    <Navbar v-if="isLoggedIn" />
    <div class="card mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0">
      <div v-if="!isLoggedIn" class="card-title text-center">
        <div
          class="col-12 pt-4 pb-4 text-center"
          :class="gdqmodeclass"
          style="color: white"
        >
          <img
            src="../assets/GDQ-Associates-White.svg"
            width="300"
            alt="GDQ Logo"
          />
        </div>
      </div>

      <div
        v-if="message"
        class="alert alert-dismissible fade show text-center"
        :class="
          error !== '' ? 'alert-danger text-black' : 'alert-success text-white'
        "
        role="alert"
      >
        {{ message }}
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          @click="message = ''"
        />
      </div>

      <div class="card-body">
        <h1 class="text-center">Mail Preferences</h1>
        <h5>Welcome to your GDQ mail preferences!</h5>
        <p>
          This page allows you to set your preferences for which e-mails you
          wish to receive from GDQ Associates. You can change your preferences
          at any time.
        </p>

        <div class="mb-3">
          <label class="form-label" for="newsletter-checkbox">Newsletter</label>
          <div class="form-check">
            <input
              id="newsletter-checkbox"
              v-model="newsletter"
              class="form-check-input"
              type="checkbox"
              name="newsletter"
              :true-value="1"
              :false-value="0"
            />
            <label class="form-check-label" for="newsletter-checkbox">
              Yes, I wish to receive the regular GDQ Newsletter (uncheck the box
              if you do not wish to receive the newsletter)
            </label>
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label" for="general-emails-checkbox"
            >General Emails</label
          >
          <div class="form-check">
            <input
              id="general-emails-checkbox"
              v-model="general_emails"
              class="form-check-input"
              type="checkbox"
              name="general_emails"
              :true-value="1"
              :false-value="0"
            />
            <label class="form-check-label" for="general-emails-checkbox">
              Yes, I wish to receive general information e-mails from GDQ
              Associates, for example information about upcoming events, news in
              the GDQ Platform and other information for GDQ Consultants.
            </label>
          </div>
        </div>

        <button
          type="button"
          class="btn btn-primary mt-3"
          @click="preferences_set"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { config } from "../../config.js";
import Navbar from "./Navbar.vue";

export default {
  name: "ConsultantMailPreferences",
  components: {
    Navbar,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    // Reactive data
    const token = computed(() => (route.params.t ? route.params.t : ""));
    const newsletter = ref(0);
    const general_emails = ref(1);
    const id = ref(0);
    const isLoggedIn = computed(() => store.getters.isLoggedIn);
    const gdqmodeclass = computed(() => {
      if (config.mode === "live") return "bg-primary";
      if (config.mode === "stage") return "bg-warning";
      return "bg-danger";
    });
    const message = ref("");
    const error = ref("");

    // Methods
    const preferences_get = () => {
      store
        .dispatch("consultant_mailpreferences_fetch", {
          subscription_token: token.value,
        })
        .then((resp) => {
          id.value = resp.data.id;
          newsletter.value = resp.data.newsletter;
          general_emails.value = resp.data.general_emails;
          error.value = resp.data.error;
        });
    };

    const preferences_set = () => {
      store
        .dispatch("consultant_mailpreferences_save", {
          id: id.value,
          newsletter: newsletter.value,
          general_emails: general_emails.value,
        })
        .then((resp) => {
          error.value = resp.data.error;
          message.value =
            resp.data.error === "" ? "Preferences saved" : error.value;
        });
    };

    // Lifecycle hook
    onMounted(() => {
      preferences_get();
    });

    return {
      // Reactive data
      token,
      newsletter,
      general_emails,
      id,
      isLoggedIn,
      gdqmodeclass,
      message,
      error,

      // Methods
      preferences_get,
      preferences_set,
    };
  },
};
</script>

<style></style>
